var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYapay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.784 21.215c0 6.075-4.88 10.955-10.956 10.955A10.924 10.924 0 0 1 4.872 21.214c0-6.075 4.88-10.955 10.956-10.955 6.075 0 10.956 4.88 10.956 10.956z",
    fill: "#FF3815"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.04 14.597c.865-.325 1.844-.49 2.983-.49h2.66v13.991h-2.495V23.27h-1.52l-2.113 4.828h-2.71l2.442-5.42a4.413 4.413 0 0 1-1.196-.975c-.324-.381-.54-.814-.706-1.303-.165-.49-.216-.974-.216-1.572v-.165c0-1.082.273-1.953.814-2.602.49-.707 1.139-1.14 2.061-1.464h-.005zm.973 6.4c.433.165.923.217 1.464.217h.649V16.06h-.706c-.814 0-1.52.216-2.061.597-.541.382-.815.974-.815 1.953v.057c0 .65.165 1.139.382 1.52.325.382.706.65 1.082.814l.005-.005z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.988 15.628h3.581c1.356 0 2.443.273 3.2.814.758.541 1.14 1.412 1.14 2.603 0 .65-.109 1.195-.325 1.628-.216.49-.49.866-.866 1.14-.381.272-.866.489-1.355.648-.541.165-1.139.217-1.788.217h-1.413v3.798h-2.17V15.628h-.004zm2.17 1.788v3.474h1.411c.706 0 1.248-.109 1.629-.382s.598-.757.598-1.412c0-.598-.165-.974-.541-1.247-.377-.273-.923-.433-1.629-.433h-1.469zM43.867 15.628h2.602l3.798 10.848h-2.17l-.922-2.66h-4.34l-.922 2.66h-1.788l3.742-10.848zm2.71 6.4-1.572-4.504-1.571 4.505h3.143zM55.637 21.869v4.555h-2.17V21.87l-3.474-6.293h2.387l2.334 4.391 2.443-4.39h2.005l-3.525 6.292z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYapay);
export default __webpack_public_path__ + "static/media/yapay.8ae23ccb62bc02248e960df8e45ebd88.svg";
export { ForwardRef as ReactComponent };